// extracted by css-extract-rspack-plugin
export default {"skeleton":"bXqPRSuGg7QlucVt","skeleton-animation":"z_eWNH1JXEAyUYmK","skeletonChild":"JeqzkNh8oYwbFqE9"};